import React, {useEffect} from 'react'

import {useDispatch, useSelector} from 'react-redux'
import {Link} from 'react-router-dom'

import {getActiveNurses, getCampaigns} from 'redux/slices/nurseCampaignSlice'
import CustomCard from '../../components/card/CustomCard'
import CustomCardHeader from '../../components/card/CustomCardHeader'
import CardBody from '../../components/card/CardBody'
import TableItemLoader from "../../components/TableItemLoader";
import {isEmpty} from "lodash";
import CustomIcon from "../../components/CustomIcon";
import {Tag} from "../../components/table/Status";

const NurseCampaign = () => {
  const dispatch = useDispatch()

  const {campaigns, loading, error} = useSelector((state) => state.campaign)

  useEffect(() => {
    dispatch(getCampaigns())
    dispatch(getActiveNurses())
  }, [])

  return (
    <div className="h-auto px-3 -mt-24 md:px-8">
      <div className="container max-w-full mx-auto">
        <div className="px-4 mb-16 grid grid-cols-1">
          <CustomCard>
            <CustomCardHeader contentPosition="none">
              <h2 className="text-2xl text-white">Campaigns</h2>
            </CustomCardHeader>
            <CardBody>
              {loading || isEmpty(campaigns) || error.length > 0 ?
                <TableItemLoader
                  loading={loading}
                  isEmpty={isEmpty(campaigns)}
                  count={10}
                  key="shift-list"
                  error={error.error}
                  retry={() => {
                    dispatch(getCampaigns())
                  }}
                  children={
                    <>
                      <div className="bg-gray-200 w-full h-[178px] rounded-md mb-3"/>
                      <div className="bg-gray-200 w-full h-[178px] rounded-md"/>
                    </>
                  }
                >
                </TableItemLoader> :
                <>
                  {campaigns?.map((campaign) => (
                    <Link
                      key={campaign?.id}
                      to={{
                        pathname: `/campaigns/${campaign.id}`,
                      }}
                    >
                      <div
                        className="custom-card flex items-start space-x-2 hover:cursor-pointer hover:shadow-md hover:bg-blue-50 hover:border-secondary-200">
                        <div
                          className="rounded-full border h-16 w-16 bg-white shrink-0 overflow-hidden flex justify-center items-center">
                          <CustomIcon icon="vaccines" className="text-secondary-500" size="3xl"/>
                        </div>
                        <div className="w-full">
                          <div
                            className="flex justify-between mb-1 text-sm sm:text-md flex-col-reverse items-start sm:flex-row sm:items-center">
                            <div className="text-lg font-medium"> {campaign?.title}</div>
                            <div
                              className={`flex items-center ml-1 text-white  text-xs ${campaign.status === true ? "bg-primary-500" : "bg-error-500"} px-2 py-1 rounded-full`}>
                              <CustomIcon className="mr-1"
                                          icon={campaign.status === true ? "autorenew" : "do_not_disturb"}/>
                              {campaign.status === true ? "Ongoing" : "Inactive"}
                            </div>
                          </div>

                          <Tag label={campaign?.type}/>
                          <p className="mt-3 text-sm mb-2">
                            {campaign?.description}
                          </p>
                          <div className="text-xs">
                            Per Vaccination Shot <span className="font-medium text-lg">NPR. {campaign?.price}</span>
                          </div>
                        </div>
                      </div>
                    </Link>
                  ))}
                </>

              }
            </CardBody>

          </CustomCard>
        </div>
      </div>
    </div>
  )
}

export default NurseCampaign
